import { FamilyMemberType } from 'app/models/scribe.models'

const home = {
  path: '/',
  get: () => '/',
}

const organizationList = {
  path: '/organizations',
  get: () => '/organizations',
  pageViewTitle: 'organization-list',
}

const membersList = {
  path: '/members',
  get: () => '/members',
  pageViewTitle: 'eligibility-record-search',
}

const usersList = {
  path: '/users',
  get: () => '/users',
  pageViewTitle: 'user-search',
}

const tagsList = {
  path: '/tags',
  get: () => '/tags',
  pageViewTitle: 'tags',
}

const tagsAdd = {
  path: '/tags/add',
  get: () => '/tags/add',
  pageViewTitle: 'tags-add-page',
}

const tagsEdit = {
  path: '/tags/:tagId/edit',
  get: (tagId: number) => `/tags/${tagId}/edit`,
  pageViewTitle: 'tags-edit-page',
}

const reportsList = {
  path: '/reports',
  get: () => '/reports',
  pageViewTitle: 'reports',
}

const organizationCreate = {
  path: '/organizations/create',
  get: () => `/organizations/create`,
  pageViewTitle: 'organization-create-page',
}

const organizationEdit = {
  path: '/organizations/:organizationId/edit',
  get: (organizationId: string) => `/organizations/${organizationId}/edit`,
  pageViewTitle: 'organization-edit-page',
}

const organizationReportingColumns = {
  path: '/organizations/:organizationId/reporting-columns',
  get: (organizationId: string) => `/organizations/${organizationId}/reporting-columns`,
  pageViewTitle: 'organization-reporting-columns',
}

const organizationReports = {
  path: '/organizations/:organizationId/reports',
  get: (organizationId: string) => `/organizations/${organizationId}/reports`,
  pageViewTitle: 'organization-reports',
}

const organizationProfile = {
  path: '/organizations/:organizationId/profile',
  get: (organizationId: string) => `/organizations/${organizationId}/profile`,
  pageViewTitle: 'organization-profile',
}

const organizationChallenges = {
  path: '/organizations/:organizationId/challenges',
  get: (organizationId: string) => `/organizations/${organizationId}/challenges`,
  pageViewTitle: 'organization-challenges',
}

const challengeLeaderboard = {
  path: '/organizations/:organizationId/challenges/:challengeId/leaderboard',
  get: (organizationId: string, challengeId: string) => {
    const challenge = encodeURIComponent(challengeId)
    return `/organizations/${organizationId}/challenges/${challenge}/leaderboard`
  },
  pageViewTitle: 'organization-challenge-leaderboard',
}

const organizationAddPlan = {
  path: '/organizations/:organizationId/plans/add',
  get: (organizationId: string) => `/organizations/${organizationId}/plans/add`,
  pageViewTitle: 'organization-add-plan-page',
}

const organizationEditPlan = {
  path: '/organizations/:organizationId/plans/:planId/edit',
  get: (organizationId: string, planId: string) =>
    `/organizations/${organizationId}/plans/${planId}/edit`,
  pageViewTitle: 'organization-edit-plan-page',
}

const organizationBilling = {
  path: '/organizations/:organizationId/billing',
  get: (organizationId: string) => `/organizations/${organizationId}/billing`,
  pageViewTitle: 'organization-billing',
}

const organizationMemberList = {
  path: '/organizations/:organizationId/members',
  get: (organizationId: string) => `/organizations/${organizationId}/members`,
  pageViewTitle: 'organization-eligibility-record-list',
}

const organizationAddMember = {
  path: '/organizations/:organizationId/members/add',
  get: (organizationId: string) => `/organizations/${organizationId}/members/add`,
  pageViewTitle: 'organization-add-member-page',
}

const organizationMemberProfile = {
  path: '/organizations/:organizationId/members/:eligibilityRecordId',
  get: (organizationId: string, eligibilityRecordId: string) =>
    `/organizations/${organizationId}/members/${eligibilityRecordId}`,
  pageViewTitle: 'eligibility-record',
}

const organizationMemberProfileChangePlan = {
  path: '/organizations/:organizationId/members/:eligibilityRecordId/change-plan',
  get: (organizationId: string, eligibilityRecordId: string) =>
    `/organizations/${organizationId}/members/${eligibilityRecordId}/change-plan`,
  pageViewTitle: 'eligibility-record-change-plan',
}

const organizationEAPRequest = {
  path: '/organizations/:organizationId/requests',
  get: (organizationId: string) => `/organizations/${organizationId}/requests`,
  pageViewTitle: 'eap-requests',
}

const organizationEngagementResources = {
  path: '/organizations/:organizationId/engagement-resources',
  get: (organizationId: string) => `/organizations/${organizationId}/engagement-resources`,
  pageViewTitle: 'organization-engagement-resources',
}

const organizationAddAdmin = {
  path: '/organizations/:organizationId/admins/add',
  get: (organizationId: string) => `/organizations/${organizationId}/admins/add`,
  pageViewTitle: 'organization-add-admin-page',
}

const userProfile = {
  path: '/user/:userId',
  get: (userId: string) => `/user/${userId}`,
  pageViewTitle: 'user-profile',
}

const userAddMember = {
  path: '/user/:userId/add-member',
  get: (userId: string, type: FamilyMemberType) => `/user/${userId}/add-member?type=${type}`,
  pageViewTitle: 'user-add-family-member-page',
}

const authCheck = {
  path: '/auth-check',
  get: () => '/auth-check',
}

const login = {
  path: '/login/*',
  get: () => '/login',
}

export {
  authCheck,
  challengeLeaderboard,
  home,
  login,
  membersList,
  organizationAddAdmin,
  organizationAddMember,
  organizationAddPlan,
  organizationBilling,
  organizationChallenges,
  organizationCreate,
  organizationEAPRequest,
  organizationEdit,
  organizationEditPlan,
  organizationEngagementResources,
  organizationList,
  organizationMemberList,
  organizationMemberProfile,
  organizationMemberProfileChangePlan,
  organizationProfile,
  organizationReportingColumns,
  organizationReports,
  reportsList,
  tagsAdd,
  tagsEdit,
  tagsList,
  userAddMember,
  userProfile,
  usersList,
}
